import { PlusCircleOutlined, WalletOutlined } from '@ant-design/icons'
import { useLastAppStateStore } from '@app/providers/router/model/store/last-app-state-store'
import { MobileAdCampaign } from '@entities/ad-campaign'
import { AdCampaignType } from '@entities/ad-campaign/api/types'
import { useAdCampaigns } from '@entities/ad-campaign/model/hooks/use-ad-campaigns'
import { useChannelStore } from '@entities/channel'
import type { Post } from '@entities/post'
import { AddAdsPostMobileModal, EditAdsPostMobileModal, usePosts } from '@entities/post'
import { savePayload } from '@entities/post/api'
import { randomId } from '@shared/lib/randomId/randomId'
import { AdPostingMobileHeader } from '@widgets/ad-posting-mobile-header'
import { BottomNavMobile } from '@widgets/page-template/ui/bottom-nav-mobile'
import { Button, Col, Row, theme, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

const { Text } = Typography

const BOT_USERNAME = process.env.BOT_USERNAME || ''

export const AdvertisingSellPage = () => {
    const {
        token: { colorBgContainer, colorError }
    } = theme.useToken()

    const { current: currentChannel } = useChannelStore()

    const {
        adCampaigns,
        actions: { deleteAdCampaign, refetchAdCampaigns }
    } = useAdCampaigns({ channelId: currentChannel?.id, type: AdCampaignType.sale })

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

    const { sessionId, action, postId, setState, reset } = useLastAppStateStore(
        useShallow(({ sessionId, action, postId, setState, reset }) => ({ sessionId, action, postId, setState, reset }))
    )

    const { currentPost } = usePosts({
        postId: postId ? postId : undefined
    })

    const onCreatePost = () => {
        const tg = (window as any).Telegram?.WebApp

        const sessionId = randomId()

        tg.showConfirm('Для создания поста, необходимо перейти в бот', async (ok?: boolean) => {
            if (!ok) return

            setState({ page: location.pathname, action: 'create-post', sessionId: sessionId })

            const payloadId = await savePayload({
                action: 'create_post',
                session_id: sessionId,
                platform: 'mobile'
            })

            const url = `https://t.me/${BOT_USERNAME}?start=payload_${payloadId}`

            tg.openTelegramLink(url)
            tg.close()
        })
    }

    const [editPostData, setEditPost] = useState<Post | null>(null)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)

    const onEditModalClose = () => {
        setEditPost(null)
        setIsEditModalOpen(false)
        reset()
    }

    const onEditModalOpen = (post: Post) => {
        setEditPost(post)
        setTimeout(() => {
            setIsEditModalOpen(true)
        }, 0)
    }

    useEffect(() => {
        if (action === 'create-post') {
            setIsCreateModalOpen(true)
        } else if (action === 'edit-post' && currentPost) {
            onEditModalOpen(currentPost)
        }
    }, [action, currentPost])

    const onCloseAddPostModal = () => {
        setIsCreateModalOpen(false)
        reset()
    }

    return (
        <>
            <AdPostingMobileHeader
                current="sale"
                title="Продажа"
                titleIcon={<WalletOutlined style={{ fontSize: '14px', color: colorError }} />}
                filter={
                    <Button type="text" onClick={onCreatePost}>
                        <PlusCircleOutlined style={{ fontSize: 23 }} />
                    </Button>
                }
            />
            <div
                style={{
                    position: 'relative',
                    background: colorBgContainer,
                    padding: '20px 16px',
                    overflow: 'auto',
                    flexGrow: 1
                }}
            >
                {adCampaigns?.length ? (
                    <Row justify={'end'} gutter={[0, 25]}>
                        {adCampaigns?.map((c) => (
                            <Col span={24} key={c.id}>
                                <MobileAdCampaign adCampaign={c} onDelete={() => deleteAdCampaign({ id: c.id })} />
                            </Col>
                        ))}
                    </Row>
                ) : (
                    <Row justify={'end'}>
                        <Col span={24}>
                            <Text>У вас пока нет рекламных кампаний</Text>
                        </Col>
                    </Row>
                )}
            </div>

            {isCreateModalOpen && sessionId && (
                <AddAdsPostMobileModal
                    open={isCreateModalOpen}
                    onClose={onCloseAddPostModal}
                    adCampaignType={AdCampaignType.sale}
                    sessionId={sessionId}
                    onSuccess={() => refetchAdCampaigns()}
                />
            )}

            {editPostData && (
                <EditAdsPostMobileModal
                    editPostData={editPostData}
                    open={isEditModalOpen}
                    onClose={onEditModalClose}
                    adCampaignName={''}
                    sessionId={sessionId}
                />
            )}
            <BottomNavMobile />
        </>
    )
}
